    <div class="game_status">
      <span
        [ngClass]="{'online':liveGameDetails.tableOpen,'offline':!liveGameDetails.tableOpen}"></span>
      <ng-container >{{liveGameDetails.tableOpen ? 'Live' : 'Offline'}}</ng-container>
    </div>
    <div class="game_ftr_wrap" *ngIf="liveGameDetails.tableOpen">
      <div class="live_game--desc live_game--balls"
        *ngIf="liveGameDetails.tableType === 'ROULETTE' && liveGameDetails.last20Results.length > 0">
        <div class="live_game--inner flex_verticalalign">
          <span *ngFor="let result of liveGameDetails.last20Results | slice:0:6;"
            class="{{result.color+'_ball'}} top_strip--parent">
            <b class="top_strip--child">{{result.result}}</b>
          </span>
        </div>
      </div>
      <div class="live_game--desc" *ngIf="liveGameDetails.tableType === 'BLACKJACK'">
        <div class="live_game--inner flex_verticalalign">
          <div class="top_strip--parent">
            <span class="top_strip--child" *ngIf="liveGameDetails.availableSeats > 0">Seats
              available: <b>{{liveGameDetails.availableSeats}}</b></span>
            <span class="top_strip--child" *ngIf="liveGameDetails.availableSeats <= 0"><b>Bet
                Behind</b></span>
          </div>
        </div>
      </div>
      <div class="live_game--bet-dtls flex_verticalalign">
        <span class="min-bet">Min Bet <b><span
              [innerHtml]="liveGameDetails.currency"></span>{{liveGameDetails.tableLimits.minBet}}</b></span>
        <span class="max-bet">Max Bet <b><span
              [innerHtml]="liveGameDetails.currency"></span>{{liveGameDetails.tableLimits.maxBet}}</b></span>
      </div>
    </div>
    <div class="game_ftr_wrap" *ngIf="!liveGameDetails.tableOpen">
      <div class="live_game--bet-dtls flex_verticalalign">
        <span class="time-left">Opens at <b>{{liveGameDetails.tableTimes}} GMT</b></span>
      </div>
    </div>
